const makeUndefined = (payloadObj) => {
  let requestPayload = {};
  Object.keys(payloadObj).forEach((item) => {
    if (payloadObj[item] !== '') {
      requestPayload = {
        ...requestPayload,
        [item]: payloadObj[item],
      };
    }
  });
  return requestPayload;
};

const isEmpty = (obj) => Object.keys(obj).length === 0;

export { makeUndefined, isEmpty };
